<template>
	<el-dialog
		:visible.sync="dialogVisible"
		:width="systemWidth * 0.3 + 'px'"
		center
		@close="handleClose"
	>
		<div
			style="text-align: center;"
			:style="{
				paddingTop: systemHeight * 0.02 + 'px',
				paddingRight: systemWidth * 0.03 + 'px'
			}"
		>
			<div style="margin-bottom: 20px;font-size:25px;font-weight: bold;">
				微信分享
			</div>

			<div style="margin-bottom: 10px;" @click="shareOrdering">
				<el-button type="primary" style="width: 80%;background-color: #409eff;"
					>订单分享</el-button
				>
			</div>

			<div style="margin-bottom: 10px;" @click="shareOrderImg">
				<el-button type="success" style="width: 80%;">订单图片分享</el-button>
			</div>

			<div style="margin-bottom: 10px;" @click="shareOrdering">
				<el-button type="danger" style="width: 80%;">全部赊欠分享</el-button>
			</div>

			<div style="margin-bottom: 10px;" @click="shareOrdering">
				<el-button type="warning" style="width: 80%;">全部订单分享</el-button>
			</div>

			<div style="margin-bottom: 10px;color:#ffffff">111</div>
		</div>
	</el-dialog>
</template>

<script>
import { test64 } from "../../../api/system-set";

import {
	generatePrintContent1,
	generatePrintContent2,
	generatePrintContent3,
	generatePrintContent4,
	generatePrintContent5,
	makebase64QRCode,
	executeShare,
	executeShare2
} from "../../../api/index.js";

export default {
	name: "ShareOrderDialog",

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		// 订单ID
		orderId: {
			type: [String, Number],
			required: true
		},
		orderItem: {
			type: [],
			required: true
		},

		systemWidth: {
			type: Number,
			default: 1920
		},

		systemHeight: {
			type: Number,
			default: 1080
		}
	},

	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit("update:visible", value);
			}
		}
	},

	methods: {
		transTime(timestamp) {
			// timestamp 为时间戳
			const date = new Date(Number(timestamp));
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			const hour = date.getHours();
			const minute = date.getMinutes();
			const second = date.getSeconds();

			return `${year}-${month
				.toString()
				.padStart(2, "0")}-${day
				.toString()
				.padStart(2, "0")} ${hour
				.toString()
				.padStart(2, "0")}:${minute
				.toString()
				.padStart(2, "0")}:${second.toString().padStart(2, "0")}`;

			// time 即为转换后的日期时间字符串
		},
		handleClose() {
			this.$emit("close");
		},

		shareOrderImg() {
			let print_type = localStorage.getItem("printer_type");

			let printer_info = JSON.parse(localStorage.getItem("printer_info"));

			if (printer_info.printer_type == "0") {
				//思普瑞特打印机

				this.printDetails = this.orderItem;
				this.handleHtmlPrinting(printer_info.use_print_template);
			}
		},

		async handleHtmlPrinting(templateType) {
			let printer_info = JSON.parse(localStorage.getItem("printer_info"));

			try {
				await makebase64QRCode(printer_info.shoukuan_link, this.printDetails);

				if (templateType === 1) {
					this.previewContent = generatePrintContent1(
						this.printDetails,
						this.transTime
					);
				} else if (templateType === 2) {
					this.previewContent = generatePrintContent2(
						this.printDetails,
						this.transTime
					);
				} else if (templateType === 3) {
					this.previewContent = generatePrintContent3(
						this.printDetails,
						this.transTime
					);
				} else if (templateType === 4) {
					if (this.printDetails.order_detail.length > 1) {
						this.previewContent = generatePrintContent3(
							this.printDetails,
							this.transTime
						);
					} else {
						this.previewContent = generatePrintContent5(this.printDetails);
					}
				}
				if (templateType === 4 && this.printDetails.order_detail.length <= 1) {
					await executeShare2(templateType, this.loading, this.previewContent);
				}
				else await executeShare(templateType, this.loading, this.previewContent);
			} catch (error) {
				console.error("打印失败：", error);
				this.$message.error("错误：" + error.message);
			} finally {
				if (this.loading) {
					this.loading.close();
					this.loading = null;
				}
			}
		},

		shareOrdering() {
			this.$message("正在研发中！！！");
			this.$emit("order-shared", this.orderId);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/set/components/share.vue